import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var LoadingSpinnerIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 16 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsx(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M8 1.5A6.5 6.5 0 1 0 14.5 8 .75.75 0 0 1 16 8a8 8 0 1 1-2.5-5.81.75.75 0 0 1-1.031 1.09A6.475 6.475 0 0 0 8 1.5Z",
            clipRule: "evenodd",
            children: /*#__PURE__*/ _jsx("animateTransform", {
                attributeName: "transform",
                attributeType: "XML",
                type: "rotate",
                dur: "1s",
                from: "0 8 8",
                to: "360 8 8",
                repeatCount: "indefinite"
            })
        })
    }));
};
